import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-section-header-group} KatHeroSectionHeaderGroup Component used display hero section header group.
 */
@register(KatHero.slotMapping.sectionHeaderGroup.name)
export class KatHeroSectionHeaderGroup extends KatLitFilteredElement {
  constructor() {
    super(
      KatHero.slotMapping.sectionHeaderGroup.name,
      KatHero.slotMapping.sectionHeaderGroup.allowed
    );
  }
}
